import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  provide,
  ref,
  PropType,
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTabs',
  props: {
  modelValue: {
    type: Object as PropType<number>,
  },
},
  emits: [
  'update:modelValue',
],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const props = __props;
const localValue = ref<number>(props.modelValue || 0);

const container = ref();

const lastTabIndex = ref(-1);

const onTabClick = (index: number) => {
  localValue.value = index;
  emits('update:modelValue', localValue.value);
};

const onTabBeforeMount = (): number => {
  lastTabIndex.value += 1;
  return lastTabIndex.value;
};

provide('onTabClick', onTabClick);
provide('onTabBeforeMount', onTabBeforeMount);
provide('currentActiveTabIndex', computed(() => localValue.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-tabs",
    ref_key: "container",
    ref: container
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})